import React from "react";
import './About.css'
import Slideshow from "./Slideshow";

const animeimg = [
    {url: "https://sm.ign.com/t/ign_ap/screenshot/default/one-piece-full-cast-header-image_7u4s.h720.jpg",
    title: "One Piece (this is my favorite Anime)"},
    {url: "https://img2.hulu.com/user/v3/artwork/213ddd1e-0c45-4f84-bb25-ea90ffd6507c?base_image_bucket_name=image_manager&base_image=20f07374-9aa7-43a2-a94c-249b522a545c&size=1200x630&format=jpeg",
    title: "Fullmetal Alchemist: Brotherhood"},
    {url: "https://m.media-amazon.com/images/I/81KDv3MIbPL._RI_.jpg",
    title: "Hunter x Hunter"},
    {url: "https://static1.dualshockersimages.com/wordpress/wp-content/uploads/2022/07/Death-Note-live-action-TV-series-adaption.jpeg",
    title: "Death Note"}
]

const videoGame = [
    {url: "https://www.notebookcheck.net/fileadmin/Notebooks/Sonstiges/Games/hearthstone_game_image.jpg",
    title: "Hearthstone"},
    {url: "https://i.ytimg.com/vi/xAPsmI_zDZs/maxresdefault.jpg",
    title: "Smite"},
    {url: "https://image.api.playstation.com/vulcan/ap/rnd/202210/2019/S8KTmZMvemfR8yfAqHvLpGIP.jpg",
    title: "Rainbow Six Siege"},
    {url: "https://i.ytimg.com/vi/GKXS_YA9s7E/maxresdefault.jpg",
    title: "Overwatch"}
]

const About = () => {

    return (
        <div id="about">
            <div className="Me">
                <h1>It's Me!</h1>
                <p>Here you're gonna find a lot of what I like!</p>
            </div>
            <div id="content">
            <div className="anime">
            <h2>Anime</h2>
            <p>I have been watching anime since I was young. I would stay up with my brother to watch it at night
            when Cartoon Network would turn into Adult Swim. These are a couple of animes that I like!
            </p>
            <Slideshow content={animeimg}/>
            </div>
            <div className="photography">
            <h2>Video Games</h2>
            <p>I like to play a lot of different games. I use to play on my Playstation 4 but a couple of years ago I built my own PC.</p>
            <Slideshow content={videoGame}/>
            </div>
            </div>
        </div>
    )
}

export default About;